import type { CalculationResult } from '#calculator/Calculator'
import { FIN_CATEGORY_BY_KEY } from '#dictionary/finCategories'

/**
 * Sums the year-1 income that the What If income slider will scale.
 *
 * The slider scales every category flagged `isActiveIncome: true`; this
 * function is the baseline against which the slider's percentage is computed
 * so the displayed ratio stays consistent with the underlying multiplier.
 */
export const sumActiveIncome = (result: CalculationResult): number =>
  result.timeline.reduce((sum, record) => {
    if (record.intent === 'DoubleEntry') return sum
    const category = FIN_CATEGORY_BY_KEY.get(record.categoryKey)
    if (!category?.isActiveIncome) return sum
    return sum + record.value
  }, 0)
